import { CMS_ICON_SPECS } from "./cmsIconCatalog";

/** Límites de imágenes de contenido (Home, logos, LABSYSO, etc.). */
export const CMS_IMAGE_SPECS = {
  maxBytes: 5 * 1024 * 1024,
  accept: "image/jpeg,image/png,image/webp,image/svg+xml",
  formatsLabel: "JPG, PNG, WebP o SVG",
  sizeHint:
    "Fotos: ≥1200 px de ancho (o retrato liderazgo 800×1200 / 2:3). Logos: 200–400 px, fondo transparente",
  weightLabel: "Máximo 5 MB",
};

export { CMS_ICON_SPECS };
